import { FormContent, LoadingViewWrapper } from 'components';
import { OnboardingKYC } from 'modules/onboarding/common/components';

interface Props {
  loading: boolean;
  token?: string;
  expirationHandler: () => Promise<string>;
}

export const LegalFirstHeadView = ({
  token,
  loading,
  expirationHandler,
}: Props) => (
  <FormContent>
    <LoadingViewWrapper loading={loading || !token}>
      <OnboardingKYC expirationHandler={expirationHandler} token={token!} />
    </LoadingViewWrapper>
  </FormContent>
);
